export default __webpack_public_path__ + "static/media/tile-installation.3581bea8.jpg";